var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "li",
    {
      directives: [
        {
          name: "on-clickaway",
          rawName: "v-on-clickaway",
          value: _vm.away,
          expression: "away"
        }
      ],
      staticClass: "sidebar__submenu",
      class: { "sidebar__submenu--active": _vm.openSubmenu }
    },
    [
      _c(
        "div",
        {
          staticClass: "sidebar__submenu-title",
          on: { click: _vm.toggleDropdown }
        },
        [
          _vm._t("title"),
          _vm._v(" "),
          _c("i", {
            staticClass: "fa fa-angle-right",
            attrs: { "aria-hidden": "true" }
          })
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "sidebar__submenu-content" },
        [_vm._t("content")],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-35481a4d", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35481a4d","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/layout/menu/Submenu.vue
// module id = 280
// module chunks = 0